import { getIncomers } from "@xyflow/react";

// ฟังก์ชันหาเส้นทาง "ต้นน้ำ" ทั้งหมด (ไล่กลับไปหาจุดเริ่มต้น)
export const getAllUpstreamNodes = (targetNode, nodes, edges, visited = new Set()) => {
    if (visited.has(targetNode.id)) return [];
    visited.add(targetNode.id);

    const incomers = getIncomers(targetNode, nodes, edges);
    let allIncomers = [...incomers];

    incomers.forEach((incomer) => {
        allIncomers = [
            ...allIncomers,
            ...getAllUpstreamNodes(incomer, nodes, edges, visited),
        ];
    });

    // ใช้ Set ลบ node ที่ซ้ำกันออก (เผื่อกรณีมีหลายเส้นทางวิ่งมาบรรจบกัน)
    return Array.from(new Set(allIncomers));
};